<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      isCreated: false
    }
  },

  mounted () {
    this.isCreated = true
  }
}
</script>

<style lang="scss">
  .pageq-enter-active, .pageq-leave-active {
    transition: opacity 0.5s;
  }
  .pageq-enter, .pageq-leave-to {
    opacity: 0;
  }
</style>
